export const capitalizeFirstLetter = (str: string) => str.charAt(0).toUpperCase() + str.slice(1)

export function groupSentence(sentence:string) {
  const groups = sentence.match(/(?:[^\s"']+|"[^"]*"|'[^']*')+/g) || []
  return groups.map((group) => group.replace(/^['"]|['"]$/g, ''))
}
